'use client';

import type { CompleteAttachment } from '@assistant-ui/react';
import { FileText } from 'lucide-react';
import { usePrivateChatImage } from '@/lib/private-chat-image';

// Waiting files use the sent-message tile treatment without an attachment
// runtime or preview action. Private images retain the native-shell auth path.
function WaitingAttachment({ attachment }: { attachment: CompleteAttachment }) {
  const image = attachment.content.find((part) => part.type === 'image');
  const file = attachment.content.find(
    (part) => part.type === 'file' && part.mimeType.startsWith('image/'),
  );
  const source =
    image?.type === 'image' ? image.image : file?.type === 'file' ? file.data : undefined;
  const src = usePrivateChatImage(source);
  return src ? (
    <div
      title={attachment.name}
      data-slot="steer-waiting-attachment"
      className="bg-muted size-14 overflow-hidden rounded-[calc(var(--composer-radius)-var(--composer-padding))] border"
    >
      <img src={src} className="size-full object-cover" alt="" />
    </div>
  ) : (
    <div
      title={attachment.name}
      data-slot="steer-waiting-attachment"
      className="bg-muted flex h-14 w-56 max-w-full items-center gap-2 rounded-[calc(var(--composer-radius)-var(--composer-padding))] border px-3 pr-6"
    >
      <FileText className="text-muted-foreground size-5 shrink-0" aria-hidden="true" />
      <span className="truncate text-sm">{attachment.name}</span>
    </div>
  );
}

export function WaitingAttachments({ attachments }: { attachments: CompleteAttachment[] }) {
  return (
    <div
      data-slot="steer-waiting-attachments"
      className="col-start-2 row-start-1 flex min-w-0 flex-row flex-wrap justify-end gap-2 opacity-60"
    >
      {attachments.map((attachment) => (
        <WaitingAttachment key={attachment.id} attachment={attachment} />
      ))}
    </div>
  );
}
